var _path, _path2, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.089 19.3592C38.089 29.8526 29.5824 38.3592 19.089 38.3592C-2.41112 39.8592 0.0890106 29.8526 0.0890106 19.3592C0.0890106 8.86581 8.08887 1.58139 19.089 0.359221C41.5889 -2.14062 38.089 8.86581 38.089 19.3592Z",
    fill: "#F2EA17"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4942 7.25149C25.4942 7.25149 20.6253 6.35813 18.276 7.93894C15.1398 10.0492 15.5262 17.2195 15.5262 17.2195C15.5262 17.2195 10.3703 22.3757 7.27675 25.4689C6.49401 26.2516 7.62032 28.2187 7.62032 28.2187C7.62032 28.5625 8.50091 28.9673 8.99538 29.2499C10.3242 30.0092 11.4015 28.9064 12.7764 28.2187H15.5262L14.8387 24.7815L18.9634 25.4689L18.276 20.6568C18.276 20.6568 22.8385 21.602 25.4942 20.6568C27.6699 19.8824 29.2005 19.247 30.3063 17.2195C31.8703 14.3523 28.9314 8.97011 28.9314 8.97011",
    stroke: "#313132",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.4005,
    cy: 13.4395,
    r: 2.68725,
    stroke: "#313132",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.cb3323459211ef137b517e251d349ea9.svg";
export { ForwardRef as ReactComponent };